export const MANAGE_DESKS_PATH = '/home/manage-desks';
